import React, { useState } from 'react';
import { ConfirmPositiveActionPopup } from 'features/nekst-widgets';
import {
  useWebhookSubscriptionTestService,
  WebhookRequestData,
  WebhookSubscription
} from 'nekst-api';
import { Text, useShowContextRequired } from 'ui-builder';

import styles from './TestWebhookPopup.module.scss';
import { RequestInfo } from './RequestInfo';

function SuccessResponse() {
  return (
    <div className={styles.successMessage}>
      Request Successful
    </div>
  );
}

const formatHeaders = (headers: Record<string, string[]>) => {
  return Object.entries(headers)
    .map(([key, values]) => {
      return `${key}: ${values.join(', ')}`;
    })
    .join('\n');
};

const formatServerResponse = (serverResponse: any) => {
  const parts = [];

  if (serverResponse.status) {
    parts.push(`Response Status Code: ${serverResponse.status}`);
  }

  if (serverResponse.headers) {
    parts.push(`Response Headers:\n ${formatHeaders(serverResponse.headers)}`);
  }

  if (serverResponse.body) {
    parts.push(serverResponse.body);
  }

  return parts.join('\n\n');
};

function ErrorResponse(props: {
  data: WebhookRequestData
}) {
  return (
    <div className={styles.errorBlock}>
      <div className={styles.errorMessage}>Request Failed</div>

      <div className={styles.responseBlock}>
        <Text bold>Status Code:</Text>
        {' '}
        {props.data.statusCode}
      </div>

      <div className={styles.responseBlock}>
        <RequestInfo label="Response:" text={formatServerResponse(props.data)} />
      </div>

    </div>
  );
}

function WebhookResult(
  props: { data: WebhookRequestData }
) {
  if (props.data.statusCode >= 200 && props.data.statusCode < 300) {
    return (<SuccessResponse />);
  } else {
    return (
      <ErrorResponse data={props.data} />
    );
  }

}

export default function TestWebhookPopup() {
  const webhookSubscriptionTestService = useWebhookSubscriptionTestService();

  const showContext = useShowContextRequired<WebhookSubscription>();

  const [result, setResult] = useState<WebhookRequestData>();

  const messageContent = (
    <>
      Press 'Send Test Request' button to send test request.
      <br />
      {result ? <WebhookResult data={result} /> : null}
    </>
  );

  return (
    <ConfirmPositiveActionPopup
      title="Test Webhook"
      message={messageContent}
      buttonText="Send Test Request"
      submitFormFunc={async () => {
        const data = await webhookSubscriptionTestService.testSubscription(
          showContext.data.id
        );
        setResult(data);
      }}
      closeOnSubmit={false}
    />
  );
}
